import React, { useEffect, useState } from 'react';
import { IconButton, Menu, MenuItem, Checkbox, FormGroup, FormControlLabel } from '@mui/material';
import FilterAlt from '@mui/icons-material/FilterAlt';
import { useDispatch } from 'react-redux';
import './FilterMenu.css';

const FilterMenu = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartments, setSelectedDepartments] = useState(['all']); 
  const [allDepartmentsLabel, setAllDepartmentsLabel] = useState('All Departments');
  const source = JSON.parse(localStorage.getItem('source'));

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDepartmentChange = (event) => {
    const { name, checked } = event.target;
    
    setSelectedDepartments(prev => {
      let newSelection;
      
      if (name === 'all') {
        if (checked) {
          newSelection = ['all', ...departments.map(dept => dept.name)];
        } else {
          newSelection = [];
        }
      } else {
        if (checked) {
          newSelection = [...prev.filter(item => item !== 'all'), name];
          
          if (newSelection.length === departments.length) {
            newSelection = ['all', ...newSelection];
          }
        } else {
          newSelection = prev.filter(item => item !== name && item !== 'all');
        }
      }
      
      const departmentsToDispatch = newSelection.includes('all') 
        ? departments.map(dept => dept.name) 
        : newSelection;
      
      dispatch({ 
        type: 'SET_DEPARTMENTS', 
        departments: departmentsToDispatch 
      });
      
      return newSelection;
    });
  };

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await fetch('https://db.neophyte.live/sentinel-api/api/sentinel/getDepartments', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            source_id: source
          })
        });

        const data = await response.json();
        
        if (data && data.data && Array.isArray(data.data)) {
          setDepartments(data.data);
          
          if (data.data.length > 0) {
            setAllDepartmentsLabel(`All`);
            setSelectedDepartments(['all', ...data.data.map(dept => dept.name)]);
            dispatch({ 
              type: 'SET_DEPARTMENTS', 
              departments: data.data.map(dept => dept.name) 
            });
          }
        }
      } catch (error) {
        console.error('Error fetching departments:', error);
      }
    };

    if (source) {
      fetchDepartments();
    }
  }, [source, dispatch]);

  const isAllSelected = selectedDepartments.includes('all');
  const isIndividualDepartmentSelected = (deptName) => {
    return selectedDepartments.includes(deptName);
  };

  return (
    <div>
      <IconButton onClick={handleClick}>
        <FilterAlt fontSize="large" className="filter-icon" />
      </IconButton>
      <Menu 
        id="filter-menu" 
        anchorEl={anchorEl} 
        keepMounted 
        open={Boolean(anchorEl)} 
        onClose={handleClose}
      >
        <FormGroup>
          <MenuItem style={{ fontWeight: 'bold' }}>Department</MenuItem>
          <MenuItem sx={{ paddingTop: 0, paddingBottom: 0 }}>
            <FormControlLabel 
              control={
                <Checkbox 
                  checked={isAllSelected}
                  onChange={handleDepartmentChange} 
                  name="all" 
                />
              } 
              label={allDepartmentsLabel}
            />
          </MenuItem>
          {departments.map((dept, index) => (
            <MenuItem key={dept.name || index} sx={{ paddingTop: 0, paddingBottom: 0 }}>
              <FormControlLabel
                control={
                  <Checkbox 
                    checked={isIndividualDepartmentSelected(dept.name)}
                    onChange={handleDepartmentChange} 
                    name={dept.name} 
                  />
                }
                label={dept.name}
              />
            </MenuItem>
          ))}
        </FormGroup>
      </Menu>
    </div>
  );
};

export default FilterMenu;